import React from "react";
import { FormControlLabel, IconButton, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import { GeneralStyle, useStyles } from "./ListOfMySpaces.styled";
import TablePagination from "@material-ui/core/TablePagination";
import { AntSwitch } from "../../helpers/antSwitch";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";

const ListOfMySpaces = ({
  loadingMySpaces,
  loadingMySpacesAfter,
  loadingMySpacesBefore,
  errorMySpaces,
  errorMySpacesAfter,
  errorMySpacesBefore,
  myspaces,
  toggleChecked,
  handleEditSpace,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  allPages,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();

  return (
    <GeneralStyle>
      {((loadingMySpaces && !errorMySpaces) ||
        (loadingMySpacesAfter && !errorMySpacesAfter) ||
        (loadingMySpacesBefore && !errorMySpacesBefore)) && (
          <Row>
            <Col
              md="12"
              className="d-flex justify-content-center align-content-center my-5"
            >
              <PointersLine color={themeConfig.button.primary} />
            </Col>
          </Row>
        )}
      {((!loadingMySpaces && errorMySpaces) ||
        (!loadingMySpacesAfter && errorMySpacesAfter) ||
        (!loadingMySpacesBefore && errorMySpacesBefore)) && (
          <Row>
            <Col
              md="12"
              className="d-flex justify-content-center align-content-center my-5"
            >
              <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
            </Col>
          </Row>
        )}
      {((!loadingMySpaces && !errorMySpaces) ||
        (!loadingMySpacesAfter && !errorMySpacesAfter) ||
        (!loadingMySpacesBefore && !errorMySpacesBefore)) && (
          <MaterialTable
            style={{ boxShadow: "none" }}
            title=""
            columns={[
              {
                title: "Name",
                field: "name",
                type: "string",
                cellStyle: {
                  padding: "0px 16px",
                },
              },
              {
                title: "Topic",
                field: "topic",
                type: "string",
                cellStyle: {
                  padding: "0px 16px",
                },
              },
              {
                title: "Country",
                field: "countryName",
                type: "string",
                cellStyle: {
                  padding: "0px 16px",
                },
              },
              {
                title: "City",
                field: "cityName",
                type: "string",
                cellStyle: {
                  padding: "0px 16px",
                },
              },
              {
                title: "Created By",
                field: "createUser",
                type: "string",
                cellStyle: {
                  padding: "0px 16px",
                },
              },
              {
                title: "Disable",
                field: "edit_record_state",
                type: "string",
                filtering: false,
                sorting: false,
                cellStyle: {
                  padding: "0px 16px",
                },
                render: (rowData) =>
                  rowData && (
                    <FormControlLabel
                      control={
                        <AntSwitch
                          size="small"
                          checked={
                            rowData?.recordState === "Active" ? true : false
                          }
                          onChange={() => {
                            let state =
                              rowData.recordState === "Active"
                                ? "Inactive"
                                : "Active";
                            rowData.recordState = state;
                            toggleChecked(rowData, state);
                          }}
                        />
                      }
                    />
                  ),
              },
              {
                title: "Actions",
                field: "internal_action",
                filtering: false,
                sorting: false,
                cellStyle: {
                  padding: "0px 16px",
                },
                render: (rowData) =>
                  rowData && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title="Edit">
                          <IconButton
                            className={classes.active}
                            onClick={() => {
                              handleEditSpace(rowData);
                            }}
                          >
                            <EditTwoTone />
                          </IconButton>
                        </Tooltip>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title="Delete">
                          <IconButton
                            className={classes.active}
                            disabled={
                              rowData?.recordState === "Active" ? true : false
                            }
                            onClick={() => {
                              setAnchorEl(null);
                              setAnchorSelected(null);
                              setOpenDeleteModal(rowData);
                            }}
                          >
                            <DeleteTwoTone />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  ),
              },
            ]
              .map((item) => ({ ...item }))
              .filter((item) => {
                return item.title !== "";
              })}
            data={myspaces}
            options={{
              maxBodyHeight: 550,
              filtering: false,
              paging: false,
              search: false,
              headerStyle: {
                zIndex: 1,
                fontWeight: "bold",
                width: "calc(13px) !important",
              },
              cellStyle: {
                padding: "5px 10px",
              },
            }}
          ></MaterialTable>
        )}
      {((!loadingMySpaces && !errorMySpaces) ||
        (!loadingMySpacesAfter && !errorMySpacesAfter) ||
        (!loadingMySpacesBefore && !errorMySpacesBefore)) && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
              <TablePagination
                component="div"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "1rem",
                }}
                count={allPages}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </div>
        )}
    </GeneralStyle>
  );
};

export default ListOfMySpaces;
